export default "__VITE_ASSET__p55hmST2__"